<style>
  .overLoad {
    background-color: #ff9595 !important;
  }


</style>

<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0"> Invoices for Letter Number '{{inner_Letter.code}}' </h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-6">
          <button *ngIf="!Procssing" type="button" (click)="Add_uploadImage1()" [disabled]="!UploadImageSrc"
            class="btn btn-info" style="margin-right: 5px;"><i class="fa  fa-plus-circle"></i> Add Attachment </button>
          <button (click)="OnSet_Back_LetterrequestcustomerFactorList()" type="button" class="btn btn-warning"><i
              class="fa fa-mail-reply"></i>
            Back </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>


      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">
            Attachments
            <button (click)="Remove_uploadImage1()" type="button" *ngIf="UploadImageSrc" class="btn  btn-danger"><i
                class="fa  fa-times-rectangle"></i> </button>
          </label>
          <img *ngIf="InProccessing_Image1" src="assets/Loading.gif" style="width: 25px;" />
          <input *ngIf="!InProccessing_Image1" #file_Image1 (change)="uploadImage1(file_Image1.files)" type="file"
            class="form-control" placeholder="Type here...">
        </div>
      </div>



      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>File</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_LetterrequestcustomerFactor">

              <td>{{DataList_LetterrequestcustomerFactor.indexOf(item)+1}}</td>

              <td>

                <a target="_blank" href="{{BaseUrl}}File/Letter/{{item.title}}"
                  class="btn btn-success"><i class="fa fa-file-excel"></i> Excel </a>

              </td>
              <td>
                <button type="button" (click)="DeleteData(item)" class="btn btn-danger"> Delete
                  <i class="fa fa-remove"></i> </button>
              </td>

            </tr>
          </tbody>
        </table>
      </div>

      <br/>
      <br/>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #39819b; color: white;">
            <tr>
              <th>#</th>
              <th>Name Equipment</th>
              <th>Invoiced Count</th>
              <th>Count in Letter</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_LetterrequestcustomerFactorDetail"
            [ngClass]="{'overLoad': item['amount']>item['realamount']}">

              <td>{{DataList_LetterrequestcustomerFactorDetail.indexOf(item)+1}}</td>
              <td>{{item['title']}}</td>
              <td>{{item['amount']}}</td>
              <td>{{item['realamount']}}</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="Next" previousLabel="Previous" (pageChange)="page = $event">
    </pagination-controls>
  </div>
</div>


<ng-template #templateImage>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> View Image </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Image.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body" style="text-align: center;">
    <img style="max-width: 350px;" src="{{BaseUrl}}File/Letter/{{ModalimageUrl}}" />
  </div>
  <div class="modal-footer">
    <a class="dropdown-item" target="_blank" href="{{BaseUrl}}File/Letter/{{ModalimageUrl}}"><i
        class="fa fa-download"></i> Download </a>
    <button type="button" class="btn btn-danger" (click)="modalRef_Image.hide()">Close</button>
  </div>
</ng-template>